//Custom components
import StatCard from '../../../UI/Card/StatCard';
import { CurrencyFormatDisplay } from '../../../UI/NumberFormatDisplay/CurrencyFormatDisplay';

const TotalGrantsWidget = ({ count }: { count: number }) => {
  return <StatCard title='Total Grants' stat={<CurrencyFormatDisplay value={count} prefix='$' />} />;
};

export default TotalGrantsWidget;
